import errorHelpers from '../helpers/errors';
import { IConfirmInvoiceRequest, ICreateInvoiceRequest, IInvoice, IUpdateInvoiceRequest } from '../interfaces/IInvoice';

class Invoices {
    static CreateInvoice = (
        siteId: number,
        createInvoiceRequest: ICreateInvoiceRequest,
        signal?: AbortSignal
    ): Promise<IInvoice> => {
        return fetch(`/invoices/${siteId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(createInvoiceRequest),
            signal,
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IInvoice>);
    };

    static ConfirmInvoice = (
        siteId: number,
        invoiceId: number,
        confirmInvoiceRequest: IConfirmInvoiceRequest
    ): Promise<string> => {
        return fetch(`/invoices/${siteId}/${invoiceId}/confirm`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(confirmInvoiceRequest)
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<string>);
    };
    
    static UpdateInvoice = (
        siteId: number,
        invoiceId: number,
        updateInvoiceRequest: IUpdateInvoiceRequest,
        signal?: AbortSignal
    ): Promise<IInvoice> => {
        return fetch(`/invoices/${siteId}/${invoiceId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updateInvoiceRequest),
            signal,
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IInvoice>);
    };
    
    static ApplyCode = (
        siteId: number,
        invoiceId: number,
        code: string
    ): Promise<IInvoice> => {
        return fetch(`/invoices/${siteId}/${invoiceId}/applycode`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code })
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IInvoice>);
    };
    
    static RemoveCode = (
        siteId: number,
        invoiceId: number,
        code: string
    ): Promise<IInvoice> => {
        return fetch(`/invoices/${siteId}/${invoiceId}/removecode`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code })
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IInvoice>);
    };
    
    static GetInvoice = (
        siteId: number,
        invoiceId: number
    ): Promise<IInvoice> => {
        return fetch(`/invoices/${siteId}/${invoiceId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IInvoice>);
    };
}

export default Invoices;
